var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCurved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.865 6.53033C12.1579 6.23744 12.1579 5.76256 11.865 5.46967C11.5721 5.17678 11.0972 5.17678 10.8043 5.46967L11.865 6.53033ZM6.668 10.6667L6.13767 11.197C6.43056 11.4899 6.90543 11.4899 7.19833 11.197L6.668 10.6667ZM5.1983 8.13633C4.9054 7.84344 4.43053 7.84344 4.13764 8.13634C3.84474 8.42923 3.84475 8.90411 4.13764 9.197L5.1983 8.13633ZM10.8043 5.46967L6.13767 10.1363L7.19833 11.197L11.865 6.53033L10.8043 5.46967ZM4.13764 9.197L6.13767 11.197L7.19832 10.1363L5.1983 8.13633L4.13764 9.197Z",
    fill: "#F9FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCurved);
export default __webpack_public_path__ + "static/media/check-curved.76994dad5941029a894c40cbaca7ca44.svg";
export { ForwardRef as ReactComponent };